import { render, staticRenderFns } from "./purchase-intention-list.vue?vue&type=template&id=d09dcc3e"
import script from "./purchase-intention-list.vue?vue&type=script&lang=ts"
export * from "./purchase-intention-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports